<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="getData"
            :search="search"
            :expanded.sync="expanded"
            :single-expand="singleExpand"
            item-key="nr"
            class="elevation-1"
            @click:row="expandRow"
          >
            <template v-slot:top>
              <v-toolbar flat :color="$store.getters.stdColorMasterDetail">
                <v-icon>mdi-receipt</v-icon>
                <v-toolbar-title>{{ $t("fakturapos.title") }}</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                >
                </v-divider>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  :label="$t('message.filter')"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" persistent max-width="800px">
                  <template v-slot:activator="{ on }">
                    <v-btn v-show="!($store.getters.showFakturaVerbucht || $store.getters.showFakturaArchiv)" @click="initItem()" class="white--text" :color="$store.getters.stdColorDark" v-on="on">{{ $t("message.newTitle") }}</v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <v-toolbar flat :color="$store.getters.stdColorLight">
                        <v-row justify="center">
                          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                        </v-row>
                      </v-toolbar>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row dense>
                          <v-col cols="6">
                            <v-text-field disabled v-model="editedItem.fakturaNr" :label="$t('fakturapos.nr')"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field disabled v-model="editedItem.position" :label="$t('fakturapos.position')"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="2">
                            <v-select
                              v-model="typItem"
                              :items="typList"
                              :label="$t('fakturapos.typ')"
                              dense
                            ></v-select>
                          </v-col>
                          <v-col cols="8">
                            <v-select v-if="typItem=='A'"
                              v-model="productItem"
                              :items="$store.getters.productList"
                              :item-text="getProductText"
                              :item-value="getProductValue"
                              :label="$t('fakturapos.artikelLeistungsNummer')"
                              dense
                            ></v-select>
                            <v-select v-if="typItem=='L'"
                              v-model="serviceItem"
                              :items="$store.getters.serviceList"
                              :item-text="getServiceText"
                              :item-value="getServiceValue"
                              :label="$t('fakturapos.artikelLeistungsNummer')"
                              dense
                            ></v-select>
                          </v-col>
                          <v-col cols="2">
                            <v-select
                              v-model="taxItem"
                              :items="$store.getters.taxList"
                              :item-text="getTaxText"
                              :item-value="getTaxValue"
                              :label="$t('fakturapos.steuerCode')"
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="12">
                            <v-text-field v-model="editedItem.text" :label="$t('fakturapos.text')" max="254" counter="254" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="6">
                            <v-text-field v-model="editedItem.kurzzeichen" :label="$t('fakturapos.kurzzeichen')" max="2" counter="2" oninput="if(this.value.length>this.max) this.value=this.value.substring(0,this.max);"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model="editedItem.datum" type="date" :label="$t('fakturapos.datum')"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="4">
                            <v-text-field v-model="editedItem.menge" :label="$t('fakturapos.menge')" min="0.01" max="9999" oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field v-model="editedItem.preis" :label="$t('fakturapos.preis')" min="0.05" max="99999" oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field v-model="editedItem.rabatt" :label="$t('fakturapos.rabatt')" min="0" max="100" oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col cols="4">
                            <v-text-field disabled v-model="editedItem.steuerBetrag" :label="$t('fakturapos.steuerBetrag')"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field disabled v-model="editedItem.nettoBetrag" :label="$t('fakturapos.nettoBetrag')"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field disabled v-model="editedItem.totalBetrag" :label="$t('fakturapos.totalBetrag')"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn :disabled="checkNavigation('prior')" class="white--text" :color="$store.getters.stdColorDark" text @click="prior()">{{ $t("message.prior") }}</v-btn>
                      <v-btn :disabled="checkNavigation('next')" class="white--text" :color="$store.getters.stdColorDark" text @click="next()">{{ $t("message.next") }}</v-btn>
                      <v-spacer></v-spacer>
                      <v-btn class="white--text" :color="$store.getters.stdColorDark" text @click="close()">{{ $t("message.cancel") }}</v-btn>
                      <v-btn class="white--text" :color="$store.getters.stdColorDark" text @click="save(true)">{{ $t("message.save") }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item="{ item }">
              <tr :bgcolor="customRowClass(item)">
                <td v-show="!($store.getters.showFakturaVerbucht || $store.getters.showFakturaArchiv)">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small class="mr-2" v-on="on" @click="editItem(item)">mdi-pencil</v-icon>
                    </template>
                    <span>{{ $t("tooltip.edit") }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on" @click="cloneItem(item)">mdi-content-copy</v-icon>
                    </template>
                    <span>{{ $t("tooltip.clone") }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on" @click="deleteItem(item)">mdi-delete</v-icon>
                    </template>
                    <span>{{ $t("tooltip.delete") }}</span>
                  </v-tooltip>
                </td>
                <td style="text-align:right">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on" :disabled="!checkItemUp(item)" :color="$store.getters.stdColorMasterDetail" @click="moveItemUp(item)">mdi-arrow-up-bold</v-icon>
                    </template>
                    <span>{{ $t("tooltip.moveItemUp") }}</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-icon small v-on="on" :disabled="!checkItemDown(item)" :color="$store.getters.stdColorMasterDetail" @click="moveItemDown(item)">mdi-arrow-down-bold</v-icon>
                    </template>
                    <span>{{ $t("tooltip.moveItemDown") }}</span>
                  </v-tooltip>
                  {{item.position}}
                </td>
                <td>{{item.kurzzeichen}}</td>
                <td>{{getLocaleDisplayDate(item.datum)}}</td>
                <td>{{item.typ}}</td>
                <td>{{item.artikelLeistungsNummer}}</td>
                <td>{{item.text}}</td>
                <td style="text-align:right">{{item.steuerCode}}</td>
                <td style="text-align:right">{{item.menge}}</td>
                <td style="text-align:right">{{item.preis}}</td>
                <td style="text-align:right">{{item.totalBetrag}}</td>
              </tr>
            </template>

          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import WebService from "@/plugins/WebService";
import EntityHelper from "@/plugins/EntityHelper";

export default {
  name: "faktura-pos-table",

  props: ['faktura'],

  data() {
    return {
      webService: new WebService(this),
      entityHelper: new EntityHelper(this),
      expandIcon: 'mdi-chevron-down',

      dialog: false,

      typItemChangeFlag: true,
      typItem: 'A',
      typList: ['A','L','T'],
      taxItem: this.$store.getters.taxList.find(o => o.code === 1),
      productItem: this.$store.getters.productList.find(o => o.nr === 'Artikel-1'),
      serviceItem: this.$store.getters.serviceList.find(o => o.nr === 'Leistung-1'),

      editedIndex: -1,
      editedItem: {
        mid: '',
        fakturaNr: 0,
        position: 0,
        typ: 'A',
        artikelNummer: '',
        leistungsNummer: '',
        menge: 0.0,
        preis: 0.0,
        text: '',
        datum: new Date(),
        storno: 'N',
        rabatt: 0.0,
        artikelLeistungsNummer: '',
        totalBetrag: 0.0,
        kurzzeichen: '',
        steuerCode: 1,
        steuerBetrag: 0.0,
        nettoBetrag: 0.0,

        calc: false
      },
      defaultItem: {
        mid: '',
        fakturaNr: 0,
        position: 0,
        typ: 'A',
        artikelNummer: 'Artikel-1',
        leistungsNummer: 'Leistung-1',
        menge: 0.0,
        preis: 0.0,
        text: '',
        datum: new Date(),
        storno: 'N',
        rabatt: 0.0,
        artikelLeistungsNummer: '',
        totalBetrag: 0.0,
        kurzzeichen: '',
        steuerCode: 1,
        steuerBetrag: 0.0,
        nettoBetrag: 0.0,

        calc: false
      },

      //table
      expanded: [],
      singleExpand: true,
      search: ''
    };
  },

  computed: {
    getData() {
      return this.faktura.fakturaPosList;
    },

    headers() {
      return [
        {
          text: this.$t("message.actions"),
          value: 'actions',
          sortable: false
        },
        {
          text: this.$t("fakturapos.position"),
          class: "blue-grey--text",
          align: "right",
          sortable: true,
          value: "position"
        },
        {
          text: this.$t("fakturapos.kurzzeichen"),
          class: "blue-grey--text",
          sortable: false,
          value: "kurzzeichen"
        },
        {
          text: this.$t("fakturapos.datum"),
          class: "blue-grey--text",
          sortable: false,
          value: "datum"
        },
        {
          text: this.$t("fakturapos.typ"),
          class: "blue-grey--text",
          sortable: false,
          value: "typ"
        },
        {
          text: this.$t("fakturapos.artikelLeistungsNummer"),
          class: "blue-grey--text",
          sortable: true,
          value: "artikelLeistungsNummer"
        },
        {
          text: this.$t("fakturapos.text"),
          class: "blue-grey--text",
          sortable: false,
          value: "text"
        },
        {
          text: this.$t("fakturapos.steuerCode"),
          class: "blue-grey--text",
          align: "right",
          sortable: false,
          value: "steuerCode"
        },
        {
          text: this.$t("fakturapos.menge"),
          class: "blue-grey--text",
          align: "right",
          sortable: false,
          value: "menge"
        },
        {
          text: this.$t("fakturapos.preis"),
          class: "blue-grey--text",
          align: "right",
          sortable: false,
          value: "preis"
        },
        {
          text: this.$t("fakturapos.totalBetrag"),
          class: "blue-grey--text",
          align: "right",
          sortable: false,
          value: "totalBetrag"
        },
        { text: "", value: "data-table-expand" }
      ];
    },

    formTitle () {
      return this.editedIndex === -1 ? this.$t("message.newTitle") : this.$t("message.editTitle")
    }
  },

  mounted() {
    //read taxes
    this.webService.getItems(this.$store.getters.taxesBase)
      .then(response => {
        this.$store.dispatch("setTaxList", response.data);
      })
      .catch(err => { console.log(err) });

    //read product data
    this.webService.getItems(this.$store.getters.productsBase)
      .then(response => {
        this.$store.dispatch("setProductList", response.data);
      })
      .catch(err => { console.log(err) });

    //read service data
    this.webService.getItems(this.$store.getters.servicesBase)
      .then(response => {
        this.$store.dispatch("setServiceList", response.data);
      })
      .catch(err => { console.log(err) });
  },

  methods: {
    expandRow(item) {
      this.expandIcon = this.expandIcon == 'mdi-chevron-down' ? 'mdi-chevron-up' : 'mdi-chevron-down'
      this.expanded = item === this.expanded[0] ? [] : [item];
    },

    customRowClass(item) {
      if (item==null)
        return ''

      if (this.editedIndex>=0)
      {
        return item.position === this.editedItem.position ? this.$store.getters.stdColorSelectedRow : ''
      }
      else
        return ''
    },

    getTaxText: item =>
      item.code + ":" + item.text+" "+item.satz.toString(),

    getTaxValue: item => item,

    getProductText: item =>
      item.nr + ":" + item.text,

    getProductValue: item => item,

    getServiceText: item =>
      item.nr + ":" + item.text,

    getServiceValue: item => item,

    initItem()
    {
      this.editedItem.fakturaNr = this.faktura.fakturaKopf.nr;
      this.typItem = this.defaultItem.typ;
      this.taxItem = this.$store.getters.taxList.find(o => o.code === this.defaultItem.steuerCode);
      this.productItem = this.$store.getters.productList.find(o => o.nr === this.defaultItem.artikelNummer);
      this.serviceItem = this.$store.getters.serviceList.find(o => o.nr === this.defaultItem.leistungsNummer);
    },

    editItem(item)
    {
      this.editedIndex = this.faktura.fakturaPosList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.typItemChangeFlag = false
      this.typItem = item.typ
      this.taxItem = this.$store.getters.taxList.find(o => o.code === item.steuerCode);
      this.productItem = this.$store.getters.productList.find(o => o.nr === item.artikelNummer);
      this.serviceItem = this.$store.getters.serviceList.find(o => o.nr === item.leistungsNummer);

      this.dialog = true
    },

    cloneItem(item)
    {
      var array = this.faktura.fakturaPosList;
      var res = Math.max.apply(Math,array.map(function(o){return o.position;}));

      var newItem=Object.assign({}, item);
      newItem.position=res+1;
      this.faktura.fakturaPosList.push(newItem);
      this.dbSave(true);
    },

    deleteItem(item)
    {
      //delete item
      const index = this.faktura.fakturaPosList.indexOf(item)
      if (confirm(this.$t("message.confirmDelete")))
      {
        this.faktura.fakturaPosList.splice(index, 1)
        this.dbSave(true);
      }
    },

    checkItemUp(item)
    {
      return this.faktura.fakturaPosList.indexOf(item) > 0
    },     

    moveItemUp(item)
    {
      //move item up
      const index = this.faktura.fakturaPosList.indexOf(item)
      if (index > 0)
      {
        //swap position
        const aktPos = this.faktura.fakturaPosList[index].position
        const upPos = this.faktura.fakturaPosList[index-1].position
        this.faktura.fakturaPosList[index].position=upPos;
        this.faktura.fakturaPosList[index-1].position=aktPos;
        this.dbSave(true);
      }
    },

    checkItemDown(item)
    {
      return this.faktura.fakturaPosList.indexOf(item) < (this.faktura.fakturaPosList.length-1)
    },     
    
    moveItemDown(item)
    {
      //move item down
      const index = this.faktura.fakturaPosList.indexOf(item)
      if (index < (this.faktura.fakturaPosList.length-1))
      {
        //swap position
        const aktPos = this.faktura.fakturaPosList[index].position
        const downPos = this.faktura.fakturaPosList[index+1].position
        this.faktura.fakturaPosList[index].position=downPos;
        this.faktura.fakturaPosList[index+1].position=aktPos;
        this.dbSave(true);
      }
    },    

    close()
    {
      this.dialog=false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save(closeOnSave)
    {
      if (this.editedIndex > -1)
      {
        Object.assign(this.faktura.fakturaPosList[this.editedIndex], this.editedItem)
      } else
      {
        this.faktura.fakturaPosList.push(this.editedItem)
      }

      if (closeOnSave)
      {
        this.dbSave(true);
        this.close();
      }
    },

    dbSave(calc)
    {
      this.faktura.fakturaKopf.calc = calc
      this.webService.updateItem(this.$store.getters.fakturaBase, this.faktura, [this.faktura.fakturaKopf.nr])
        .then(response => {
          if (response.request.status==200)
          {
            if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
            {
              //re-read faktura data
              this.webService.getItems(this.$store.getters.fakturaEntities+"/"+this.getFakturaTyp().toString())
                .then(response => {
                  this.$store.dispatch("setFakturaList", response.data);
                })
                .catch(err => { console.log(err) });
            }
            else
            {
              this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
            }
          }
        })
        .catch(err => { console.log(err) });
    },

    prior()
    {
      this.save(false)
      this.editedIndex--
      this.editedItem = Object.assign({}, this.faktura.fakturaPosList[this.editedIndex])
      this.typItemChangeFlag = false
      this.typItem = this.editedItem.typ;
      this.taxItem = this.$store.getters.taxList.find(o => o.code === this.editedItem.steuerCode);
      this.productItem = this.$store.getters.productList.find(o => o.nr === this.editedItem.artikelNummer);
      this.serviceItem = this.$store.getters.serviceList.find(o => o.nr === this.editedItem.leistungsNummer);
    },

    next()
    {
      this.save(false)
      this.editedIndex++
      this.editedItem = Object.assign({}, this.faktura.fakturaPosList[this.editedIndex])
      this.typItemChangeFlag = false
      this.typItem = this.editedItem.typ;
      this.taxItem = this.$store.getters.taxList.find(o => o.code === this.editedItem.steuerCode);
      this.productItem = this.$store.getters.productList.find(o => o.nr === this.editedItem.artikelNummer);
      this.serviceItem = this.$store.getters.serviceList.find(o => o.nr === this.editedItem.leistungsNummer);
    },

    checkNavigation(mode)
    {
      //new record
      if (this.editedIndex==-1)
        return true
      if (mode=='prior')
      {
        return !(this.editedIndex>0)
      }
      else
      {
        return !(this.editedIndex<(this.faktura.fakturaPosList.length-1))
      }
    },

    calcItem(item)
    {
      this.webService
        .calcItem(this.$store.getters.calcInvoiceItem, item)
        .then(response => {
          this.editedItem.nettoBetrag = this.roundNumber(response.data.nettoBetrag)
          this.editedItem.steuerBetrag = this.roundNumber(response.data.steuerBetrag)
          this.editedItem.totalBetrag = this.roundNumber(response.data.totalBetrag)
        });
      return;
    },

    getFakturaTyp()
    {
      if (this.$store.getters.showFaktura)
        return this.$store.getters.FAKTURA_FAKTURA
      if (this.$store.getters.showRapport)
        return this.$store.getters.FAKTURA_RAPPORT
      if (this.$store.getters.showOfferte)
        return this.$store.getters.FAKTURA_OFFERTE
      if (this.$store.getters.showAuftrag)
        return this.$store.getters.FAKTURA_AUFTRAG
    },

    getLocaleDisplayDate(isoDate)
    {
      if (isoDate!=null)
        return new Date(isoDate).toLocaleDateString('de-CH');
      else
        return isoDate;
    },

    roundNumber(number)
    {
      return Number(Math.round(number+'e2')+'e-2');
    }

  },

  watch: {
    expanded: {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        // do something when row is expanded, probably re-read some data
      }
    },

    typItem: {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal!==null && !this.typItemChangeFlag)
        {
          this.typItemChangeFlag = true
          return
        }
        if (newVal!==null && this.typItemChangeFlag)
        {
          this.editedItem.typ=newVal;
          this.editedItem.text='';
          this.editedItem.artikelNummer='';
          this.editedItem.leistungsNummer='';
          this.editedItem.artikelLeistungsNummer='';
          this.editedItem.preis=0;
          this.editedItem.steuerCode=1;
          switch (newVal) {
            case 'A':
              this.serviceItem = null;
              this.productItem = this.$store.getters.productList.find(o => o.nr === 'Artikel-1');
              break;
            case 'L':
              this.productItem = null;
              this.serviceItem = this.$store.getters.serviceList.find(o => o.nr === 'Leistung-1');
              break;
            case 'T':
              this.serviceItem = null;
              this.productItem = null;
              break;
            default:
              console.log('wrong param');
          }
        }
      }
    },

    productItem: {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal!==null)
        {
          if (this.editedItem.typ=='A')
          {
            this.editedItem.text=newVal.text;
            this.editedItem.artikelNummer=newVal.nr;
            this.editedItem.artikelLeistungsNummer=newVal.nr;
            this.editedItem.preis=newVal.vpreis;
            this.editedItem.steuerCode=newVal.taxCode;
            this.taxItem=this.$store.getters.taxList.find(o => o.code === newVal.taxCode);
          }
        }
      }
    },

    serviceItem: {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal!==null)
        {
          if (this.editedItem.typ=='L')
          {
            this.editedItem.text=newVal.text;
            this.editedItem.leistungsNummer=newVal.nr;
            this.editedItem.artikelLeistungsNummer=newVal.nr;
            this.editedItem.preis=newVal.vpreis;
            this.editedItem.steuerCode=newVal.taxCode;
            this.taxItem=this.$store.getters.taxList.find(o => o.code === newVal.taxCode);
          }
        }
      }
    },

    'editedItem.menge': {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        this.calcItem(this.editedItem);
      }
    },

    'editedItem.preis': {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        this.calcItem(this.editedItem);
      }
    },

    'editedItem.rabatt': {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        this.calcItem(this.editedItem);
      }
    },

    taxItem: {
      // eslint-disable-next-line
      handler(newVal, oldVal) {
        if (newVal!=null)
        {
          this.editedItem.steuerCode=newVal.code;
          this.calcItem(this.editedItem);
        }
      }
    },

    dialog (val) {
      val || this.close()
    }
  }

};
</script>

<style scoped>
.large-slider >>> .v-slider {
  height: 60px;
}
</style>
